import { Component, EventEmitter, Input, Output } from '@angular/core'
import { ViewerService } from '../../../../case-viewer/neuroglancer-frame/viewer.service'
@Component({
    selector: 'app-viewer-zoom-controls',
    templateUrl: './viewer-zoom-controls.component.html',
    styleUrls: ['./viewer-zoom-controls.component.scss'],
})
export class ViewerZoomControlsComponent {
    @Input() zoom: number | null = null
    @Output() zoomChange = new EventEmitter<number>()

    constructor(readonly viewer: ViewerService) {}

    get zoomText(): string {
        return this.zoom === null ? '-' : this.zoom === 1 ? '1' : (1 / this.zoom).toFixed(2)
    }

    setZoom(zoomString: string): void {
        const zoomNumber = Number(zoomString)
        if (isNaN(zoomNumber) || zoomNumber <= 0) return

        this.zoomChange.emit(1 / zoomNumber)
    }

    resetZoom(): void {
        this.zoomChange.emit(1)
    }
}
